import useSWR from "swr";
import { cmsSubscriptionService } from "../../services/cms-subscription/cms-subscription.service.instance";
import type { ICmsSubscription } from "../../services/cms-subscription/entities/cms-subscription/cms-subscription.entity.interface";

const CMS_ORDERED_SUBSCRIPTIONS_KEY = "cms-ordered-subscriptions";
const CMS_ORDERED_SUBSCRIPTIONS_CACHE_SECONDS = 2;
const CMS_ORDERED_SUBSCRIPTIONS_CACHE_MILLISECONDS = CMS_ORDERED_SUBSCRIPTIONS_CACHE_SECONDS * 1000;

export function useCmsOrderedSubscriptions(): ICmsSubscription[] | undefined {
  const { data: cmsOrderedSubscriptions } = useSWR<ICmsSubscription[]>(
    CMS_ORDERED_SUBSCRIPTIONS_KEY,
    function fetchOrderedSubscriptions() {
      return cmsSubscriptionService.getOrderedSubscriptions();
    },
    {
      dedupingInterval: CMS_ORDERED_SUBSCRIPTIONS_CACHE_MILLISECONDS,
    }
  );

  return cmsOrderedSubscriptions;
}
